import { createGyymApiClient, GyymApiClient } from '@gyym/sdk'
import type { GetStaticProps, GetStaticPropsContext } from 'next'

import { ISRPrefetch } from '#utils/types'

export const withGyymISR = (
  prefetch: ISRPrefetch,
  { revalidate = 60 }: { revalidate?: number } = {},
): GetStaticProps => {
  return async (ctx: GetStaticPropsContext) => {
    const client: GyymApiClient = createGyymApiClient({
      baseURL: process.env.NEXT_PUBLIC_API_HOST,
    })

    try {
      const ret = await prefetch(ctx, client)

      const { cache, props } = Array.isArray(ret)
        ? { cache: ret, props: {} }
        : ret

      const results = await Promise.all(
        cache.map(async (config) => {
          // Skip request if apiRequest is not returned from prefetchConfig function
          if (!config) return Promise.resolve({})

          const [key, result] = await Promise.resolve(config)

          return {
            [key]: result,
          }
        }),
      )

      const fallback = results.reduce(
        (acc, result) => ({
          ...acc,
          ...result,
        }),
        {},
      )

      return {
        props: {
          ...props,
          swr: {
            fallback,
          },
        },
        revalidate,
      }
    } catch (e) {
      if (client.isHttpError(e) && e.status === 404) {
        return {
          notFound: true,
        } as const
      }

      console.error(e)

      throw e
    }
  }
}
